import React from 'react';
import { Hero } from '../components/home/Hero';
import { Ticker } from '../components/Ticker';
import { WhatWeDo } from '../components/home/WhatWeDo';
import { Results } from '../components/home/Results';
import { Process } from '../components/home/Process';
import { GalleryStrip } from '../components/home/GalleryStrip';
import { Statement } from '../components/home/Statement';
import { Reviews } from '../components/home/Reviews';
import { Faq } from '../components/Faq';
import { BookingCta } from '../components/BookingCta';
export function Home() {
  return <>
      <Hero data-id="element-1080" data-mp="24ivapcawopbf" />
      <Ticker data-id="element-1081" data-mp="29gdcmiqia49x" />
      <WhatWeDo data-id="element-1082" data-mp="29flotu35hau7" />
      <Results data-id="element-1083" data-mp="29f2bkqog3ami" />
      <Process data-id="element-1084" data-mp="29ek5l2bzdi1e" />
      <GalleryStrip data-id="element-1085" data-mp="29i7zw3p928h6" />
      <Statement data-id="element-1086" data-mp="2dhqj8v1fabhw" />
      <Reviews data-id="element-1087" data-mp="2di8djm4iyfn6" />
      <section className="mx-auto max-w-shell px-5 py-16 sm:px-6 lg:px-10 lg:py-28" data-id="element-1088" data-mp="2dirsqv2sipxi">
        <h2 className="max-w-xl font-display text-3xl font-extrabold leading-[1.05] tracking-tightest text-chalk sm:text-4xl" data-id="element-1089" data-mp="3kw1zzb7o95b9">
          Goed om te weten
        </h2>
        <div className="mt-10" data-id="element-1090" data-mp="30wrpwio1y1gl">
          <Faq data-id="element-1091" data-mp="30x1j0f4e8oqi" />
        </div>
      </section>
      <BookingCta data-id="element-1092" data-mp="30up285adgkf1" />
    </>;
}